import type { AnalysisResult } from "./mockData";

const STORAGE_KEY = "kibbe-analysis-history";

export function saveAnalysis(result: AnalysisResult): void {
  const history = getHistory();
  history.unshift(result);
  // Keep last 50 analyses max
  if (history.length > 50) history.length = 50;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
  } catch {
    // If localStorage is full (large images), remove oldest entries
    while (history.length > 1) {
      history.pop();
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
        break;
      } catch {
        continue;
      }
    }
  }
}

export function getHistory(): AnalysisResult[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    return JSON.parse(raw) as AnalysisResult[];
  } catch {
    return [];
  }
}

export function getAnalysisById(id: string): AnalysisResult | null {
  const history = getHistory();
  return history.find((a) => a.id === id) ?? null;
}

export function deleteAnalysis(id: string): void {
  const history = getHistory().filter((a) => a.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
}
